import { createSelector } from 'reselect'

export const getData = state => state.reportTransportChanges.getIn(['all', 'objects'])
export const createGetDataSelector = () => createSelector([getData], data => data)

export const getDatetime = state => state.reportTransportChanges.getIn(['all', 'datetime'])
